// @ts-strict-ignore
import React, { FC } from 'react'
import Modal from '../modal'
import { Button, Card, CardContent, Text } from '@mytours/components'
import strings from 'mobile_web/strings'
import './styles.less'

interface ConfirmationModalProps {
	isOpen: boolean
	onDidDismiss?: () => void
	onAccept?: () => void
	question?: string
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({ isOpen, onDidDismiss, onAccept, question }) => (
	<Modal isOpen={isOpen} onDidDismiss={onDidDismiss} cssClass="confirmation-modal">
		<Card variant="ios">
			<CardContent>
				<div className="confirmation-modal-text">
					<i className="far fa-circle-exclamation" />
					<Text variant="inherit">{question}</Text>
				</div>
				<div>
					<Button variant="clear" aria-label={strings.close} onClick={onDidDismiss}>
						{strings.cancel}
					</Button>
					<Button variant="clear" aria-label={strings.close} onClick={onAccept} className="-submit">
						{strings.submit}
					</Button>
				</div>
			</CardContent>
		</Card>
	</Modal>
)

export default ConfirmationModal
